/**
 * contiene la información para el manejo del inventario.
 */
export const defaultInventario = () => {
    return {
        tipo: '',
        mys: 0,
        ubicaciones:[],
        empresa: '',
        fecha: null,
        uuid: '',
        ubicEmpresa: []
    }
}

/**
 * Carga todas las variables declaradas en el proceso.
 */
export default {
    selectedInventario: defaultInventario(),
    inventariosProcesados: [],
    optempresa: [
        { value: '', text: '' }
    ],
    optbases: [
        { value: '', text: '' }
    ],
    optareas: [
        { value: '', text: '' }
    ],
    inventario: [],
    descargaInventario: '',
    ubicEmpresa:[],
    contratistas: [],
    error: false,
    listaEmpresas: [],
    empresa:{},
    background_process: [],
}
